import { render, staticRenderFns } from "./ButtonWithLoad.vue?vue&type=template&id=f55f4750&scoped=true&"
import script from "./ButtonWithLoad.vue?vue&type=script&lang=js&"
export * from "./ButtonWithLoad.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithLoad.vue?vue&type=style&index=0&id=f55f4750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55f4750",
  null
  
)

export default component.exports